import EmojiPicker, { Theme } from "emoji-picker-react";
import useThemeStore from "../store/useThemeStore";

const ThemedEmojiPicker = (props) => {
  const isDark = useThemeStore((state) => state.isDark);

  return (
    <EmojiPicker
      {...props}
      theme={isDark ? Theme.DARK : Theme.LIGHT}
    />
  );
};

export default ThemedEmojiPicker;
